import { BUSINESS_LINE_TYPE_UPPERCASE } from 'settings/constants/businessLine'
import T from 'T'

export const BUSINESS_LINES_TABS = {
  ALL_BUSINESS_LINES: 'ALL',
  ...BUSINESS_LINE_TYPE_UPPERCASE,
}

export const NONE_BUSINESS_LINE_OPTION = {
  label: T.NONE,
  value: '',
}
